
export function defineColor(occupancyRate) {
  if (occupancyRate < 0.85) {
    return 'care-unit-free';
  } else if (occupancyRate < 0.95) {
    return 'care-unit-full';
  } else {
    return 'care-unit-over';
  }
}

export function formatFirstname(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatLastname(string) {
  if (!string) return "";
  return string.toUpperCase();
}